export const detectWrap = (className) => {
  const wrappedItems = [];
  let prevItem = {};
  let currItem = {};
  const items = document.getElementsByClassName(className);

  for (let i = 0; i < items.length; i++) {
    currItem = items[i].getBoundingClientRect();
    if (prevItem && prevItem.top < currItem.top) {
      wrappedItems.push(items[i]);
    }
    prevItem = currItem;
  }

  return wrappedItems;
};
